import app from 'app';
import templateUrl from './sponsorSelector.html';
import './sponsorSelector.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

function SponsorSelectorCtrl() {
  const SponsorSelector = this;

  SponsorSelector.changeSponsorship = function(sponsorship) {
    SponsorSelector.currentSponsorship = sponsorship;
    logEvent('sponsorshipChanged', {
      category: eventCategories.SETTINGS
    });
    SponsorSelector.$close();
  };
}

app.component('sponsorSelector', {
  bindings: {
    $close: '<',
    allSponsorships: '<',
    currentSponsorship: '<'
  },
  controller: SponsorSelectorCtrl,
  controllerAs: 'SponsorSelector',
  templateUrl
});

export default 'sponsorSelector';
